module.exports = __webpack_public_path__ + "img/evry-logo-black.4a3d8582.png";